import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";

// components
import Navbar from "../components/navbar/Navbar";
import PerformanceHeader from "../components/performance/PerformanceHeader";
import PrePreFooter from "../components/pre-footer/PrePreFooter";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const PerformanceWrapper = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_product_overview.json`;

  const [fetchedData, setFetchedData] = useState("");

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    setFetchedData(data.product);
    // console.log(data);
  }

  // run the data fetch on load
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const currentPage = window.location.pathname;
    ReactGA.send({
      hitType: "pageview",
      page: "/performance",
      title: "performance",
    });
    console.log("GA Page View Sent:", currentPage); // Debugging
  }, []);

  return (
    <>
      {/* <Navbar /> */}
      <PerformanceHeader />
      <PrePreFooter>
        <p className="font-bold mb-4">
          Past performance is historical and not a guarantee of future results.
        </p>
        <ol className="list-decimal">
          <li className="text-base">{fetchedData.nav_calc_note}</li>
          <li className="text-base">{fetchedData.distribution_note}</li>
          <li className="text-base">
            <span className="font-bold">
              Performance data shown represents past performance and does not
              predict or guarantee future results. Investment returns and
              principal value will fluctuate so that shares redeemed may be
              worth more or less than their original cost. Current performance
              may be higher or lower than the performance shown. Total returns
              for a period of less than one year are cumulative. Returns without
              sales charges would be lower if the sales charges were included.
              Returns assume reinvestment of dividends and capital gains.
              Returns shown are preliminary.
            </span>
            &nbsp;
            <span>
              Returns shown reflect the percent change in the NAV per share from
              the beginning of the applicable period, plus the amount of any
              distribution per share declared in the period. All returns shown
              assume distributions are paid in cash, are derived from unaudited
              financial information and are net of all DIR expenses, including
              general and administrative expenses, transaction related expenses,
              management fees, performance participation allocation, and share
              class specific fees, but exclude the impact of early repurchase
              deductions on the repurchase of shares that have been outstanding
              for less than one year. Returns listed as (with sales load) assume
              payment of the full upfront sales charge at initial subscription
              (1.5% for Class D shares; 3.5% for Class S and Class T shares).
              Class D, Class S and Class T shares listed as (no sales load)
              exclude up-front selling commissions and dealer manager fees.
              1-Year and 3-Year refer to the twelve and thirty-six months,
              respectively, prior to current month-end. Inception to date
              (“ITD”) and 3-Year returns for DIR are annualized consistent with
              the IPA Practice Guideline 2018. Return information is not a
              measure used under GAAP. The returns have been prepared using
              unaudited data and valuations of the underlying investments in
              DIR’s portfolio, which are estimates of fair value and form the
              basis for DIR’s NAV. Valuations based upon unaudited reports from
              the underlying investments may be subject to later adjustments,
              may not correspond to realized value and may not accurately
              reflect the price at which assets could be liquidated.
            </span>
          </li>
          <li className="text-base">
            On May 15, 2026, the DIR Board of Directors approved a change in
            Valuation Policy to determine and publish the Company’s NAV on a
            quarterly basis, starting with the June 30, 2026 NAV.
          </li>
        </ol>
      </PrePreFooter>
      <PreFooter />
      <Footer />
    </>
  );
};

export default PerformanceWrapper;
